<p-toast></p-toast>

<p-panel header="Maintenance Records">
  <ng-template #icons>
    <div class="flex gap-2">
      <p-button icon="pi pi-trash" [label]="deleteButtonLabel()" severity="danger" (onClick)="deleteRecords()"
        [disabled]="selectedRecords().length === 0 || loading()" outlined>
      </p-button>

      <p-button icon="pi pi-refresh" label="Refresh" severity="secondary" (onClick)="refreshRecords()"
        [disabled]="loading()" outlined>
      </p-button>
    </div>
  </ng-template>

  <ng-template #content>
    <div class="mb-3">
      <label for="assetType" class="block text-sm font-medium mb-1">Asset Type</label>
      <p-dropdown id="assetType" [options]="assetTypeOptions" [ngModel]="selectedAssetType()"
        (ngModelChange)="onAssetTypeChange($event)" optionLabel="label" optionValue="value"
        placeholder="Select an asset type" styleClass="w-full md:w-80">
      </p-dropdown>
    </div>

    <p-divider></p-divider>

    <p-table [value]="(data() || [])" [totalRecords]="(totalRecords() || 0)" [paginator]="true" [rows]="rows"
      [first]="first" [lazy]="true" [loading]="loading()" [loadingIcon]="'pi pi-spin pi-cog'"
      [tableStyle]="{ 'min-width': '50rem' }" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} maintenance records"
      paginatorDropdownAppendTo="body" [rowsPerPageOptions]="[10, 25, 50]" (onPage)="onPage($event)" selectionMode="multiple"
      [selection]="selectedRecords()" (selectionChange)="selectedRecords.set($event)" dataKey="id" size="small">
      <ng-template pTemplate="header">
        <tr class="column-filters">
          <th></th>
          <th *ngFor="let col of columns" class="p-1">
            <input *ngIf="isFilterable(col)"
              pInputText
              type="text"
              class="w-full text-sm"
              [ngModel]="filterValue(col.field)"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onColumnFilter(col.field, $event)"
              (click)="stopRowEvent($event)"
              (mousedown)="stopRowEvent($event)"
              (keydown)="stopRowEvent($event)"
              [placeholder]="col.header"
              autocomplete="off" />
          </th>
          <th class="p-1 text-center">
            <p-button *ngIf="hasActiveFilters"
              icon="pi pi-times"
              label="Clear filters"
              severity="secondary"
              (onClick)="clearFilter()"
              outlined>
            </p-button>
          </th>
        </tr>
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th *ngFor="let col of columns">{{ col.header }}</th>
          <th style="width: 7rem">Action</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item" (dblclick)="onRowDblClick(item)">
          <td>
            <p-tableCheckbox [value]="item"></p-tableCheckbox>
          </td>
          <td>{{ item.asset_code }}</td>
          <td>{{ item.grp_no }}</td>
          <td>{{ item.maintenance_date | date:'dd/MM/yyyy' }}</td>
          <td>
            <a *ngIf="item.maintenance_documentation" [href]="getFileUrl(item.maintenance_documentation)" target="_blank"
              class="text-blue-600 hover:underline">
              {{ getFileName(item.maintenance_documentation) }}
            </a>
          </td>
          <td>{{ item.next_maintenance_date | date:'dd/MM/yyyy' }}</td>
          <td>{{ getMaintenanceDetailsName(item.maintenance_details) }}</td>
          <td>{{ getMaintenanceTypeName(item.maintenance_type) }}</td>
          <td>{{ item.quantity }}</td>
          <td>{{ item.rate | currency:'RM':'symbol':'1.2-2' }}</td>
          <td>{{ item.total_cost | currency:'RM':'symbol':'1.2-2' }}</td>
          <td>{{ item.remarks }}</td>
          <td>
            <div class="flex items-center gap-1">
              <p-button
                icon="pi pi-pencil"
                [rounded]="true"
                [text]="true"
                severity="secondary"
                size="small"
                [disabled]="loading()"
                ariaLabel="Edit"
                (onClick)="editRecord(item, $event)">
              </p-button>
              <p-button
                icon="pi pi-trash"
                [rounded]="true"
                [text]="true"
                severity="danger"
                size="small"
                [disabled]="loading()"
                ariaLabel="Delete"
                (onClick)="deleteSingleRecord(item, $event)">
              </p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="14" class="text-center p-4">No maintenance records found</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-panel>

<p-confirmDialog></p-confirmDialog>

<app-maintenance-asset-form-dialog [(visible)]="itemDialog" [record]="item" [readOnly]="isDialogReadOnly()"
  [loading]="loading()" [assetType]="selectedAssetType()" [requireParentAsset]="true"
  (save)="onDialogSave($event)" (fileSelected)="onFileSelected($event)">
</app-maintenance-asset-form-dialog>
